export const DASH_PPS = {
  '198.100.100.100': {
    'military': 39.83,
    'citizen': 60.17,
    'doctor': 1.21,
    'candidate': 46.74,
    'professor': 3.25,
    'docent': 24.39,
    'staffing_scientists': 57.72
  },
  '193.200.200.100': {
    'military': 40.36,
    'citizen': 59.64,
    'doctor': 4.73,
    'candidate': 46.54,
    'professor': 3.63,
    'docent': 20.36,
    'staffing_scientists': 55.27
  },
  '10.79.200.80': {
    'military': 43.54,
    'citizen': 56.46,
    'doctor': 8.13,
    'candidate': 66.02,
    'professor': 7.17,
    'docent': 32.06,
    'staffing_scientists': 76.08
  },
  '192.168.199.201': {
    'military': 39.6,
    'citizen': 60.41,
    'doctor': 6.68,
    'candidate': 63.12,
    'professor': 8.66,
    'docent': 26.73,
    'staffing_scientists': 70.54
  },
  '193.167.10.18': {
    'military': 33.99,
    'citizen': 66.01,
    'doctor': 6.72,
    'candidate': 50.98,
    'professor': 4.74,
    'docent': 25.69,
    'staffing_scientists': 58.49
  },
  '193.100.100.100': {
    'military': 43.19,
    'citizen': 56.81,
    'doctor': 11.24,
    'candidate': 60.94,
    'professor': 8.28,
    'docent': 37.27,
    'staffing_scientists': 75.14
  },
}